<template>
  <div>
    <img
        :src="productThumbnail(product)"
        :ref="`thumbnail${product.id}`"
        class="cursor-pointer p-0 rounded"
        style="object-fit: cover"
        width="80"
        height="80"
        @click="triggerFileInput"
    />

    <!-- input مخفی برای انتخاب تصویر -->
    <input
        type="file"
        :ref="`fileInput${product.id}`"
        style="display: none"
        accept="image/*"
        @change="handleFileChange"
    />
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {productThumbnail} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'

export default {
  name: "ProductImageManager",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    productThumbnail,

    triggerFileInput() {
      let inputName = `fileInput${this.product.id}`
      this.$refs[inputName].click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.submit(file);
      }
    },

    submit(file) {
      // ساخت آبجکت فرم هماهنگ با productDataShape
      const form = {
        product_id: this.product.id,
        mainImage: file,
        images: []
      };
      this.$store.dispatch("Product/updateProductImage", form)
          .then((data) => {
            let thumbnail = data.data.data.thumbnail
            let inputName = `thumbnail${this.product.id}`
            this.$refs[inputName].src = thumbnail;
            toast('با موفقیت انجام شد', 'با موفقیت انجام شد','success','top-left')
          })
          .catch((err) => {
            console.error(err);
          });
    },
  },
};
</script>
